import { render, staticRenderFns } from "./page-demo-select.vue?vue&type=template&id=f0b34c16&scoped=true&"
import script from "./page-demo-select.vue?vue&type=script&lang=js&"
export * from "./page-demo-select.vue?vue&type=script&lang=js&"
import style0 from "./page-demo-select.vue?vue&type=style&index=0&id=f0b34c16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b34c16",
  null
  
)

export default component.exports